import React from 'react';

interface MobileDataCardRow {
  label: string;
  value: React.ReactNode;
}

interface MobileDataCardProps {
  title: React.ReactNode;
  badge?: React.ReactNode;
  subtitle?: React.ReactNode;
  rows: MobileDataCardRow[];
  actions?: React.ReactNode;
}

const MobileDataCard: React.FC<MobileDataCardProps> = ({ title, badge, subtitle, rows, actions }) => {
  return (
    <article className="rounded-2xl border border-slate-200/80 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-base font-semibold text-[#111D4E] break-words">{title}</div>
          {subtitle ? <div className="mt-1 text-sm text-slate-600 break-words">{subtitle}</div> : null}
        </div>
        {badge ? <div className="shrink-0">{badge}</div> : null}
      </div>

      <dl className="mt-4 space-y-3">
        {rows.map((row) => (
          <div key={row.label} className="border-t border-slate-100 pt-3 first:border-t-0 first:pt-0">
            <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">{row.label}</dt>
            <dd className="mt-1 text-[15px] text-slate-800 break-words">{row.value}</dd>
          </div>
        ))}
      </dl>

      {actions ? <div className="mt-4 flex flex-col gap-2">{actions}</div> : null}
    </article>
  );
};

export default MobileDataCard;
